import consumer from './consumer'

consumer.subscriptions.create('PlatformUpdatesChannel', {
  received(data) {
    window.dispatchEvent(new CustomEvent('landport:platform-update', { detail: data }))
  }
})
